import clsx from "clsx";
import React, { ComponentProps, ElementType, ReactNode } from "react";

interface OverridableComponentProps<E extends ElementType> {
    as?: E;
}

interface NoTranslateOwnProps {
    /** If provided, "no-translate" class would be added when condition satisfies */
    if?: boolean;

    children: ReactNode;
    className?: string;
}

type NoTranslateProps<E extends ElementType> = NoTranslateOwnProps & OverridableComponentProps<E> & ComponentProps<E>;

export const NoTranslate = <E extends ElementType = "span">({
    if: shouldNotTranslate = true,
    as: ElementTypeProperty = "span",
    children,
    className,
    ...rest
}: NoTranslateProps<E>) => {
    return (
        <ElementTypeProperty className={clsx({ "no-translate": shouldNotTranslate }, className)} {...rest}>
            {children}
        </ElementTypeProperty>
    );
};
